import removeMarkdown from "remove-markdown";
import { Fetched, ImgixCrop, ImgixImage, Organization, RequestError } from "../types";
import fetch from "./fetch";
const organizationId = window.ORGANIZATION_ID;

type GenericOrganizationFetchError = { type: "generic" };
type OrganizationError = GenericOrganizationFetchError;

export const fetchOrganization = async (): Promise<
  Fetched<Organization> | RequestError<OrganizationError>
> => {
  const orgResponse = await fetch(`/api/public/v3.0/organizations/${organizationId}`);

  if (orgResponse.type !== "success") {
    return {
      status: "error",
      error: {
        type: "generic",
      },
    };
  }

  const orgJson = orgResponse.response;
  const dataBag = orgJson.data || {};
  const imgixImage = dataBag.image
    ? ({
        url: dataBag.image,
        crop: {
          height: dataBag.image_crop.height,
          width: dataBag.image_crop.width,
          offsetX: dataBag.image_crop.x,
          offsetY: dataBag.image_crop.y,
        } as ImgixCrop,
      } as ImgixImage)
    : null;
  return {
    status: "fetched",
    entity: {
      name: orgJson.name,
      description: orgJson.md_description
        ? dataBag.description
        : removeMarkdown(dataBag.description),
      location: dataBag.location ? dataBag.location.city : "",
      website: dataBag.website,
      priceMode: dataBag.public
        ? dataBag.public.price_mode || "PRICE_MODE_DEFAULT"
        : "PRICE_MODE_DEFAULT",
      images: orgJson.images,
      image: imgixImage,
      mdDescription: orgJson.md_description,
    },
  };
};
